import {
  BACKEND_MARK_STATUS_ENABLED,
  type LC_AttendanceMarkItem,
  type LC_GetAttendanceMarksOut,
  type AttendanceMark,
  type AttendanceMarksPage,
} from '../types/attendanceMarks.types';


export function mapAttendanceMark(item: LC_AttendanceMarkItem): AttendanceMark {
  return {
    id: item.historicalAttendanceId,
    fullName: item.fullName,
    rut: item.employeeTaxIdentificationNumber,
    eventName: item.eventName,
    locationName: item.ubicationName,
    date: item.markDate,
    time: item.markTime,
    status: item.markStatus,
    isEnabled: item.markStatus === BACKEND_MARK_STATUS_ENABLED,
    modifiedDate: item.modifiedDate,
    modifiedByName: item.modifiedByName,
  };
}

export function mapAttendanceMarksPage(data: LC_GetAttendanceMarksOut): AttendanceMarksPage {
  return {
    items: data.items.map(mapAttendanceMark),
    pagination: {
      currentPage: data.pagination.currentPage,
      pageSize: data.pagination.pageSize,
      totalRecords: data.pagination.totalRecords,
      totalPages: data.pagination.totalPages,
      hasPreviousPage: data.pagination.hasPreviousPage,
      hasNextPage: data.pagination.hasNextPage,
    },
  };
}
